// import React, { useState } from "react";
// import api from "../../api/axios";

// const CreateBrandModal = ({ show, onClose, onCreated }) => {
//   const [brandName, setBrandName] = useState("");
//   const [brandImage, setBrandImage] = useState(null);
//   const [loading, setLoading] = useState(false);

//   const submitHandler = async (e) => {
//     e.preventDefault();

//     if (!brandImage) {
//       alert("Brand image is required");
//       return;
//     }

//     const formData = new FormData();
//     formData.append("brand_name", brandName);
//     formData.append("brand_image", brandImage);

//     try {
//       setLoading(true);
//       await api.post("companyblog/admin/brands/", formData);
//       onCreated();       // refresh list
//       onClose();         // close modal
//       setBrandName("");
//       setBrandImage(null);
//     } catch (err) {
//       alert("Failed to create brand");
//     } finally {
//       setLoading(false);
//     }
//   };

//   if (!show) return null;

//   return (
//     <div className="modal fade show d-block" style={{ background: "rgba(0,0,0,0.5)" }}>
//       <div className="modal-dialog modal-lg">
//         <div className="modal-content">

//           <div className="modal-header">
//             <h5 className="modal-title">Create Brand</h5>
//             <button type="button" className="btn-close" onClick={onClose}></button>
//           </div>

//           <form onSubmit={submitHandler}>
//             <div className="modal-body">

//               <div className="mb-3">
//                 <label className="form-label">Brand Name *</label>
//                 <input
//                   type="text"
//                   className="form-control"
//                   required
//                   value={brandName}
//                   onChange={(e) => setBrandName(e.target.value)}
//                 />
//               </div>

//               <div className="mb-3">
//                 <label className="form-label">Brand Image *</label>
//                 <input
//                   type="file"
//                   className="form-control"
//                   required
//                   onChange={(e) => setBrandImage(e.target.files[0])}
//                 />
//                 <small className="text-muted">
//                   Required dimension: 400 × 400 px
//                 </small>
//               </div>

//             </div>

//             <div className="modal-footer">
//               <button
//                 type="button"
//                 className="btn btn-secondary"
//                 onClick={onClose}
//               >
//                 Close
//               </button>

//               <button className="btn btn-primary" disabled={loading}>
//                 {loading ? "Saving..." : "Save"}
//               </button>
//             </div>
//           </form>

//         </div>
//       </div>
//     </div>
//   );
// };

// export default CreateBrandModal;
import React, { useState } from "react";
import api from "../../api/axios";

const CreateBrandModal = ({ show, onClose, onCreated }) => {
  const [brandName, setBrandName] = useState("");
  const [brandImage, setBrandImage] = useState(null);
  const [loading, setLoading] = useState(false);

  const submitHandler = async (e) => {
    e.preventDefault();

    if (!brandImage) {
      alert("Brand image is required");
      return;
    }

    const formData = new FormData();
    formData.append("brand_name", brandName);
    formData.append("brand_image", brandImage);
    formData.append("is_active", true);

    try {
      setLoading(true);

      await api.post(
        "companyblog/admin/brands/",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      onCreated();   // refresh brand list
      onClose();     // close modal

      // reset form
      setBrandName("");
      setBrandImage(null);

    } catch (err) {
      console.error(err.response?.data);
      alert("Failed to create brand");
    } finally {
      setLoading(false);
    }
  };

  if (!show) return null;

  return (
    <div
      className="modal fade show d-block"
      style={{ background: "rgba(0,0,0,0.5)" }}
    >
      <div className="modal-dialog modal-lg">
        <div className="modal-content">

          {/* Header */}
          <div className="modal-header">
            <h5 className="modal-title">Create Brand</h5>
            <button
              type="button"
              className="btn-close"
              onClick={onClose}
            />
          </div>

          {/* Form */}
          <form onSubmit={submitHandler}>
            <div className="modal-body">

              <div className="mb-3">
                <label className="form-label">Brand Name *</label>
                <input
                  type="text"
                  className="form-control"
                  required
                  value={brandName}
                  onChange={(e) => setBrandName(e.target.value)}
                />
              </div>

              <div className="mb-3">
                <label className="form-label">Brand Image *</label>
                <input
                  type="file"
                  className="form-control"
                  required
                  onChange={(e) => setBrandImage(e.target.files[0])}
                />
                <small className="text-muted">
                  Required dimension: 400 × 400 px
                </small>
              </div>

            </div>

            {/* Footer */}
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                onClick={onClose}
              >
                Close
              </button>

              <button
                type="submit"
                className="btn btn-primary"
                disabled={loading}
              >
                {loading ? "Saving..." : "Save"}
              </button>
            </div>
          </form>

        </div>
      </div>
    </div>
  );
};

export default CreateBrandModal;
